import React, { useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useInstance} from 'react-ioc';
import {useMutation} from '@apollo/client';
import {Button, Checkbox,Form, Radio} from 'antd';
import _ from 'lodash';

import {Store} from '../../model/store/Store';
import {createAnket, createAnketVariables} from '../../shared/graphql/__generated__/createAnket';
import {MUTATION_CREATE_ANKET} from '../../shared/graphql/anket';
import {InputWithValue} from '../Index/Widgets/InputWithValue';

import options from './options.json'
import steps from './steps.json'

import cls from '../Index/Widgets/MultiForm.module.scss';

interface StepProps {
    defaultStep: number
    onUpdate: () => void
}

export const Step = ({defaultStep, onUpdate}: StepProps) => {

    const [loading, setLoading] = useState(false);
    const [create] = useMutation<createAnket, createAnketVariables>(MUTATION_CREATE_ANKET);
    const {auth} = useInstance(Store)
    // const navigate = useNavigate()
    const {t} = useTranslation()
    // const [step, setStep] = useState(defaultStep)


    // кровь
    // образ жизни
    // вредные привычки
    // память
    // для женщин
    // хронические заболевания
    // симптомы
    // препараты
    // прочее

    // сохраняем данные на бэке по мере заполнения
    // если есть данные нескольких шагов - продолжаем от этого шага

    const onFinish = async (data:any) => {

        setLoading(true);

        for (const [key, value] of Object.entries(data)) {

            // console.log(key, value)

            await create({
                variables: {
                    data: {
                        identifier: key,
                        value: `${value}`,
                    }
                },
            })
        }

        auth.needUpdate()
        onUpdate()

        // setStep(step + 1);
        window.scrollTo(0, 0);

        setLoading(false);

    }

    return (
            <Form layout={'vertical'} onFinish={onFinish} validateTrigger={'onFinish'} disabled={loading} scrollToFirstError={true}>
                {
                    _.map(steps[defaultStep].depends, item => {

                        if (item.gender === 'all' || item.gender === auth.data?.gender) {
                            const unit = _.filter(options, option => option.identifier === item.identifier)[0]

                            let input = undefined
                            if (unit.unit === 'cm' || unit.unit === 'kg') {
                                input =
                                    <InputWithValue indicator={item} style={{width: '100%'}} addonAfter={t(unit.unit)}/>
                            }
                            if (unit.unit === 'variants') {
                                input = <Radio.Group optionType="button"
                                                     buttonStyle="solid"
                                                     options={_.map(unit.variants, item => ({
                                                         label: t(item.label),
                                                         value: item.value
                                                     }))}/>
                            }
                            if (unit.unit === 'list') {
                                input = <Radio.Group optionType="default" className={cls.list}
                                                     options={_.map(unit.variants, item => ({
                                                         label: t(item.label),
                                                         value: item.value
                                                     }))}/>
                            }
                            if (unit.unit === 'multi') {
                                input = <Checkbox.Group className={cls.list}
                                                        options={_.map(unit.variants, item => ({
                                                            label: t(item.label),
                                                            value: item.value
                                                        }))}/>
                            }

                            return (
                                <Form.Item name={item.identifier} label={t(unit.label)} key={item.identifier} rules={[
                                    {required: true, message: t('Please, fill data')!},
                                ]}>
                                    {input}
                                </Form.Item>
                            )
                        } else {
                            return null
                        }
                    })
                }
                <Form.Item>
                    <Button loading={loading} htmlType={'submit'} type={'primary'} block>Далее</Button>
                </Form.Item>
            </Form>

    )

}